/**
 * Pipe Function - Function composition to chain code execution
 * Doc: https://vanslaars.io/post/create-pipe-function/
 */
const _pipe = (f, g) => (...args) => g(f(...args))
const pipe = (...fns) => fns.reduce(_pipe)

export default pipe
